import React from 'react';
import { Book, CheckCircle, Shield, FileText, Activity, Users, Lock, AlertTriangle, TrendingUp, Megaphone, MessageSquare, Target } from 'lucide-react';
export function LibraryTeaserSection() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-gray-50 border-t border-gray-100" data-id="element-730">
      <div className="max-w-7xl mx-auto" data-id="element-731">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-732">
          <h2 className="text-sm font-bold tracking-widest text-gray-500 uppercase mb-4 font-sans" data-id="element-733">
            WHAT COULD YOU BUILD?
          </h2>
          <p className="text-3xl md:text-4xl font-['Syne'] font-bold text-black mb-6" data-id="element-734">
            Smart organizations are capturing their
            <br data-id="element-735" />
            institutional intelligence right now.
          </p>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-736">
            Here's what their libraries look like:
          </p>
        </div>

        {/* Library Cards Grid - 3 COLUMNS */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-737">
          {/* Pharma Card */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-738">
            <div className="p-8" data-id="element-739">
              <div className="mb-6" data-id="element-740">
                <h3 className="text-xl font-bold font-['Syne'] text-black" data-id="element-741">
                  PHARMA
                </h3>
                <p className="text-sm text-gray-500 font-medium" data-id="element-742">Life Sciences</p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-743">
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-745" />} text="Brand Voice (Consumer)" data-id="element-744" />
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-747" />} text="Brand Voice (HCP)" data-id="element-746" />
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-749" />} text="FDA Promotional Compliance" data-id="element-748" />
                <GuardrailItem icon={<Activity className="w-4 h-4" data-id="element-751" />} text="Adverse Event Protocol" data-id="element-750" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-753" />} text="Clinical Trial Messaging" data-id="element-752" />
                <GuardrailItem icon={<Lock className="w-4 h-4" data-id="element-755" />} text="Patient Privacy (HIPAA)" data-id="element-754" />
                <GuardrailItem icon={<AlertTriangle className="w-4 h-4" data-id="element-757" />} text="Crisis Communication" data-id="element-756" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-759" />} text="Executive Ghostwriting" data-id="element-758" />
                <div className="pl-7 text-sm text-gray-400 font-medium italic" data-id="element-760">
                  ... hundreds more
                </div>
              </div>

              <div className="bg-green-50 border border-green-100 rounded-lg p-4 flex items-center gap-3" data-id="element-761">
                <TrendingUp className="w-5 h-5 text-green-600" data-id="element-762" />
                <span className="text-sm font-medium text-green-800" data-id="element-763">
                  Result: <span className="font-bold" data-id="element-764">7 days → 1 day</span>{' '}
                  approval cycles
                </span>
              </div>
            </div>
          </div>

          {/* Financial Services Card */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-765">
            <div className="p-8" data-id="element-766">
              <div className="mb-6" data-id="element-767">
                <h3 className="text-xl font-bold font-['Syne'] text-black" data-id="element-768">
                  FINANCIAL SERVICES
                </h3>
                <p className="text-sm text-gray-500 font-medium" data-id="element-769">
                  Wealth Management
                </p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-770">
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-772" />} text="SEC Compliance (Forward-Looking)" data-id="element-771" />
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-774" />} text="FINRA Social Media" data-id="element-773" />
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-776" />} text="Client Segmentation (HNW vs. Retail)" data-id="element-775" />
                <GuardrailItem icon={<AlertTriangle className="w-4 h-4" data-id="element-778" />} text="Risk Disclosure Language" data-id="element-777" />
                <GuardrailItem icon={<CheckCircle className="w-4 h-4" data-id="element-780" />} text="Fiduciary Standard Adherence" data-id="element-779" />
                <GuardrailItem icon={<TrendingUp className="w-4 h-4" data-id="element-782" />} text="Market Commentary Guardrails" data-id="element-781" />
                <GuardrailItem icon={<Activity className="w-4 h-4" data-id="element-784" />} text="Counterfactual Reasoning" data-id="element-783" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-786" />} text="Annual Review Documentation" data-id="element-785" />
                <div className="pl-7 text-sm text-gray-400 font-medium italic" data-id="element-787">
                  ... hundreds more
                </div>
              </div>

              <div className="bg-green-50 border border-green-100 rounded-lg p-4 flex items-center gap-3" data-id="element-788">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-789" />
                <span className="text-sm font-medium text-green-800" data-id="element-790">
                  Result:{' '}
                  <span className="font-bold" data-id="element-791">Zero compliance incidents</span>{' '}
                 
                </span>
              </div>
            </div>
          </div>

          {/* Marketing & Communications Card */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-792">
            <div className="p-8" data-id="element-793">
              <div className="mb-6" data-id="element-794">
                <h3 className="text-xl font-bold font-['Syne'] text-black" data-id="element-795">
                  MARKETING
                </h3>
                <p className="text-sm text-gray-500 font-medium" data-id="element-796">
                  Enterprise Brand
                </p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-797">
                <GuardrailItem icon={<Megaphone className="w-4 h-4" data-id="element-799" />} text="Brand Voice Consistency" data-id="element-798" />
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-801" />} text="Audience Segmentation (B2B vs. B2C)" data-id="element-800" />
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-803" />} text="Legal Disclaimer Requirements" data-id="element-802" />
                <GuardrailItem icon={<Lock className="w-4 h-4" data-id="element-805" />} text="Competitor Mention Policy" data-id="element-804" />
                <GuardrailItem icon={<MessageSquare className="w-4 h-4" data-id="element-807" />} text="Social Media Guidelines" data-id="element-806" />
                <GuardrailItem icon={<Target className="w-4 h-4" data-id="element-809" />} text="Product Positioning" data-id="element-808" />
                <GuardrailItem icon={<AlertTriangle className="w-4 h-4" data-id="element-811" />} text="Crisis Communication" data-id="element-810" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-813" />} text="Executive Ghostwriting" data-id="element-812" />
                <div className="pl-7 text-sm text-gray-400 font-medium italic" data-id="element-814">
                  ... hundreds more
                </div>
              </div>

              <div className="bg-green-50 border border-green-100 rounded-lg p-4 flex items-center gap-3" data-id="element-815">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-816" />
                <span className="text-sm font-medium text-green-800" data-id="element-817">
                  Result: <span className="font-bold" data-id="element-818">100% on-brand</span>{' '}
                  outputs
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Closing */}
        <div className="text-center max-w-3xl mx-auto" data-id="element-819">
          <p className="text-xl md:text-2xl font-light text-gray-800 leading-relaxed font-['Syne']" data-id="element-820">
            You know your regulatory boundaries. You know your brand standards.
            You know what your top performers do differently.
            <br data-id="element-821" />
            <br data-id="element-822" />
            <span className="font-bold text-black" data-id="element-823">
              What if that knowledge was machine-readable?
            </span>
          </p>
        </div>
      </div>
    </section>;
}
function GuardrailItem({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-3 text-gray-700" data-id="element-824">
      <div className="text-gray-400 flex-shrink-0" data-id="element-825">{icon}</div>
      <span className="text-sm font-medium" data-id="element-826">{text}</span>
    </div>;
}